import React from 'react'

export default function AdvanceProject(props) {
    return (
        <div className="project">
            <div className="thumbnail">
                <img src={props.thumbnail} alt={props.thumbnail} loading={'lazy'} />
            </div>
            <div className="content">
                <h2>{props.heading}</h2>
                <p>{props.content}</p>
            </div>
            <div className="demo-btn" >
                {props.demoLink === "" ? "" : <a href={props.demoLink} target="_blank" rel="noreferrer"><i className="fa fa-play" aria-hidden="true"></i> Demo</a>}
                <a href={props.githubLink} target="_blank" rel="noreferrer"><i className="fa-brands fa-github"></i> GitHub Link</a>
            </div>
        </div>
    )
}
